import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcSegmentInputComponent } from './fc-segment-input.component';


@NgModule({
  declarations: [
    FcSegmentInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcSegmentInputComponent
  ]
})
export class FcSegmentModule {}
